/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Export_DoneInputs */

const en_us2_history_transfer_export_done = /** @type {(inputs: History_Transfer_Export_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File ready`)
};

const pt_br2_history_transfer_export_done = /** @type {(inputs: History_Transfer_Export_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo pronto`)
};

const es_419_history_transfer_export_done = /** @type {(inputs: History_Transfer_Export_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo listo`)
};

const pt_pt2_history_transfer_export_done = /** @type {(inputs: History_Transfer_Export_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ficheiro pronto`)
};

const fr_fr2_history_transfer_export_done = /** @type {(inputs: History_Transfer_Export_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier prêt`)
};

const de_de2_history_transfer_export_done = /** @type {(inputs: History_Transfer_Export_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei bereit`)
};

const it_it2_history_transfer_export_done = /** @type {(inputs: History_Transfer_Export_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File pronto`)
};

/**
* | output |
* | --- |
* | "File ready" |
*
* @param {History_Transfer_Export_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_export_done = /** @type {((inputs?: History_Transfer_Export_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Export_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_export_done(inputs)
	if (locale === "es-419") return es_419_history_transfer_export_done(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_export_done(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_export_done(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_export_done(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_export_done(inputs)
	return en_us2_history_transfer_export_done(inputs)
});
export { history_transfer_export_done as "history-transfer.export_done" }